import React, { useState } from "react";
import { Menu } from "antd";
import "../Styles/DesktopMenuStyles.css";
import { Link, useLocation } from "react-router-dom";

const DesktopMenu = () => {
  const [activeDrawer, setActiveDrawer] = useState(null);
  const location = useLocation();
  const [currentKey, setCurrentKey] = useState(location.pathname);

  // ✅ ABOUT ICAST submenu items
  const aboutSubMenus = [
    { key: "/genisis", label: "Genesis of ICAST", link: "/genisis" },
    { key: "/icast-2025", label: "ICAST 2025", link: "/icast-2025" },
    { key: "/tracks", label: "Theme & Tracks", link: "/tracks" },
    { key: "/governance", label: "Governance Structure", link: "/governance" },
  ];

  // ✅ CALL FOR CONTENT is a page + has submenu items
  const contentSubMenus = [
    { key: "/content", label: "Call For Content", link: "/content", isHeader: true }, // <-- page itself
    { key: "/call-for-papers", label: "Call For Papers", link: "/call-for-papers" },
    { key: "/call-for-session", label: "Call For Sessions", link: "/call-for-session" },
    { key: "/author-resources", label: "Author Resources", link: "/author-resources" },
    { key: "/registration", label: "Registration", link: "/registration" },
  ];

  // ✅ Combine + divider
  const aboutAndContentMenus = [
    ...aboutSubMenus,
    { key: "__divider_call_for_content__",  isDivider: true },
    ...contentSubMenus,
  ];

  const handleMenuClick = (e) => {
    setCurrentKey(e.key);
  };

  return (
    <div className="desktop-menu-container">
      <Menu
        mode="horizontal"
        className="desktop-menu"
        selectedKeys={[currentKey]}
        onClick={handleMenuClick}
      >
        {/* ✅ ABOUT ICAST (now includes Call for Content page + items) */}
        <div
          className="menu-item-with-drawer"
          onMouseEnter={() => setActiveDrawer("about")}
          onMouseLeave={() => setActiveDrawer(null)}
        >
          <Menu.Item key="/about">
            <Link to="/" onClick={() => setCurrentKey("/")}>
              ABOUT ICAST
            </Link>
          </Menu.Item>

          {activeDrawer === "about" && (
            <div className="submenu-drawer">
              <ul className="submenu-list">
                {aboutAndContentMenus.map((item) => {
                  if (item.isDivider) {
                    return (
                      <li key={item.key} className="submenu-divider call-for-content-divider">
                        {item.label}
                      </li>
                    );
                  }

                  return (
                    <li
                      key={item.key}
                      className={`submenu-item ${item.isHeader ? "submenu-item-header" : ""}`}
                    >
                      <Link to={item.link} onClick={() => setCurrentKey(item.key)}>
                        {item.label}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>

        {/* ❌ Removed CALL FOR CONTENT top-level menu */}

        {/* Other Menu Items */}
        <Menu.Item key="/conference-program">
          <Link to="/conference-program">CONFERENCE PROGRAM</Link>
        </Menu.Item>
         <Menu.Item key="/icast-delegates">
          <Link to="/icast-delegates">ICAST DELEGATES</Link>
        </Menu.Item>

        <Menu.Item key="/expo">
          <Link to="/expo">PARTNERS & SPONSORS</Link>
        </Menu.Item>

        

       
        <Menu.Item key="/press-release">
          <Link to="/press-release">MEDIA RELEASE</Link>
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default DesktopMenu;
